<script setup>
import { watch } from 'vue';

import MetricCard from './overview/MetricCard.vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import TeamTable from './overview/TeamTable.vue';
import { useOnVisible } from '../composables/useOnVisible';

const store = useStore();
const { target, visible } = useOnVisible();

const uiFlags = useMapGetter('getOverviewUIFlags');
const teamConversationMetric = useMapGetter('getTeamConversationMetric');
const teams = useMapGetter('teams/getTeams');

const fetchData = () => store.dispatch('fetchTeamConversationMetric');

watch(
  visible,
  isVisible => {
    if (!isVisible) return;
    store.dispatch('teams/get');
    fetchData();
  },
  { immediate: true }
);
</script>

<template>
  <div ref="target" class="flex flex-row flex-wrap max-w-full">
    <MetricCard
      :header="$t('OVERVIEW_REPORTS.TEAM_CONVERSATIONS.HEADER')"
      :live="false"
    >
      <TeamTable
        :teams="teams"
        :team-metrics="teamConversationMetric"
        :is-loading="uiFlags.isFetchingTeamConversationMetric"
      />
    </MetricCard>
  </div>
</template>
